import React, {useEffect, useState} from 'react';
import {Input, Spin} from "antd";
import {SearchIcon} from "lucide-react";

function SearchInputRaw({setSearch, setPage, placeHolder = 'جستجو کنید ...'}) {

    const [inputSearchValue, setInputSearchValue] = useState()
    const [searchInputLoading, setSearchInputLoading] = useState(false)

    useEffect(() => {
        setSearchInputLoading(true)
        const delaySearch = setTimeout(() => {
            setSearch(inputSearchValue)
            setPage(1)
            setSearchInputLoading(false)
        }, 1000)

        return () => clearTimeout(delaySearch)

    }, [inputSearchValue]);

    const icon = searchInputLoading ? <Spin size="small"/> : <SearchIcon className="h-4 w-4 text-gray-400"/>

    return (
        <div>

            <Input suffix={icon} placeholder={placeHolder}
                   rootClassName={`md:w-96`}
                   onChange={
                       (e) => {
                           setInputSearchValue(e.target.value)
                       }
                   }
                   value={inputSearchValue}
            />

        </div>
    );
}

export default SearchInputRaw;